import { render, staticRenderFns } from "./RunningContest.vue?vue&type=template&id=a7fcfca8"
import script from "./RunningContest.vue?vue&type=script&lang=js"
export * from "./RunningContest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports